// extracted by mini-css-extract-plugin
export var caption = "Figure-module--caption--SgaTZ";
export var root = "Figure-module--root--69xHd";